import React from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '../lib/api'

// `publicView` drops the signed-in chrome for a page an anonymous visitor can
// reach. Both nav items are actively misleading there: "Saved trades" leads
// straight to a 401, and "Sign out" offers to end a session that doesn't exist.
// The wordmark stops being a link for the same reason — /connect is not a
// useful destination for someone who just opened a shared link.
export default function Layout({ children, wide = false, publicView = false }) {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const signOut = useMutation({
    mutationFn: () => api.signOut(),
    onSuccess: () => {
      queryClient.clear()
      navigate('/connect')
    },
  })

  return (
    <div className="min-h-screen bg-slate-950">
      <header className="border-b border-slate-800 bg-slate-900">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-3 py-3 sm:px-4">
          {publicView ? (
            <span className="text-sm font-semibold tracking-tight">lolcollusion</span>
          ) : (
            <Link to="/connect" className="text-sm font-semibold tracking-tight">
              lolcollusion
            </Link>
          )}

          {!publicView && (
            <nav className="flex items-center gap-4">
              <NavLink
                to="/trades"
                className={({ isActive }) =>
                  `text-xs ${
                    isActive
                      ? 'font-medium text-slate-100'
                      : 'text-slate-400 hover:text-slate-200'
                  }`
                }
              >
                Saved trades
              </NavLink>

              <button
                type="button"
                onClick={() => signOut.mutate()}
                className="text-xs text-slate-400 hover:text-slate-200"
              >
                Sign out
              </button>
            </nav>
          )}
        </div>
      </header>

      <main className={`mx-auto px-3 py-5 sm:px-4 sm:py-6 ${wide ? 'max-w-6xl' : 'max-w-3xl'}`}>
        {children}
      </main>
    </div>
  )
}
